/* Productgalerij op desktop (Stan 24-10-2026): bij veel foto's niet eindeloos doorscrollen tot "Complete the look".
   Toont de eerste 5 foto's (1 groot + 4) en daaronder een knop "View all photos (23)". Op mobiel is de galerij een slider
   en doet dit script niets. Tekst uit het woordenboek (rf.pdp.*), via window.rfTekst in layout/theme.liquid. */
(function () {
  var MAX = 5;
  function bouw(g) {
    var ul = g.querySelector('.media-gallery__grid'); if (!ul || g.dataset.rfGalerij) return;
    var n = ul.children.length; if (n <= MAX) return;
    g.dataset.rfGalerij = '1'; g.classList.add('rf-galerij-kort');
    var t = window.rfTekst || {};
    var knop = document.createElement('button'); knop.type = 'button'; knop.className = 'button button-secondary rf-galerij-knop';
    var meer = (t.alleFotos || 'View all photos (__N__)').replace('__N__', n), minder = t.minderFotos || 'Show fewer photos';
    knop.textContent = meer;
    knop.addEventListener('click', function () {
      var kort = g.classList.toggle('rf-galerij-kort'); knop.textContent = kort ? meer : minder;
      if (kort) g.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    ul.insertAdjacentElement('afterend', knop);
  }
  function alles() { document.querySelectorAll('media-gallery.media-gallery--two-column, media-gallery.media-gallery--one-column').forEach(bouw); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alles); else alles();
})();
